import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api/tasks`);

export const getTasks = async (projectId, sprintId = null, backlogOnly = false) => {
  const response = await API.get("/", {
    params: {
      project_id: projectId,
      sprint_id: sprintId,
      backlog_only: backlogOnly
    }
  });
  return response.data;
};

export const createTask = async (data) => {
  const response = await API.post("/", data);
  return response.data;
};

export const updateTask = async (taskId, data) => {
  const response = await API.put(`/${taskId}`, data);
  return response.data;
};

export const updateTaskStatus = async (taskId, status) => {
  const response = await API.patch(`/${taskId}/status`, { status });
  return response.data;
};

export const deleteTask = async (taskId) => {
  const response = await API.delete(`/${taskId}`);
  return response.data;
};

export const getTaskComments = async (taskId) => {
  const response = await API.get(`/${taskId}/comments`);
  return response.data;
};

export const createTaskComment = async (taskId, data) => {
  const response = await API.post(`/${taskId}/comments`, data);
  return response.data;
};

export const deleteTaskComment = async (commentId) => {
  const response = await API.delete(`/comments/${commentId}`);
  return response.data;
};
